module.exports = __webpack_public_path__ + "static/media/x.d92002f0.svg";